/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


jQuery(function () {
  useLogoReplace();
  useExpandMenu();
  useHeaderAccordionMenu();
  useFooterAccordionMenu();
  useNewsCategoryAccordionMenu();
  useModal();
});

function useLogoReplace() {
  var header = document.querySelector('.header');
  if (!header) return;

  var logoElement = header.querySelector('.header__logo img');
  var logoInfo = {
    el: logoElement,
    off: logoElement.src,
    on: logoElement.src.replace('_white', '_black')
  };

  header.addEventListener('mouseenter', function (e) {
    logoInfo.el.src = logoInfo.on;
  });
  header.addEventListener('mouseleave', function (e) {
    logoInfo.el.src = logoInfo.off;
  });
}

function useExpandMenu() {
  var menuExpandTriggers = document.querySelectorAll('.header__menu-expand-trigger');
  var currentTriggerElement = undefined;
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(function (item) {
    item.addEventListener('mouseover', function (e) {
      if (currentTriggerElement !== undefined) {
        currentTriggerElement.nextElementSibling.classList.remove('expanded');
        currentTriggerElement.parentNode.classList.remove('active');
      }
      item.nextElementSibling.classList.add('expanded');
      item.parentNode.classList.add('active');
      currentTriggerElement = item;
    });
  });
  var menuExpandBody = document.querySelectorAll('.header__menu-expand');
  Array.prototype.slice.call(menuExpandBody, 0).forEach(function (item) {
    item.addEventListener('mouseleave', function (e) {
      item.classList.remove('expanded');
      item.parentNode.classList.remove('active');
      currentTriggerElement = undefined;
    });
  });
  document.body.addEventListener('mouseleave', function (e) {
    Array.prototype.slice.call(menuExpandBody, 0).forEach(function (item) {
      item.classList.remove('expanded');
      item.parentNode.classList.remove('active');
    });
    currentTriggerElement = undefined;
  });
}

function useHeaderAccordionMenu() {
  var menuBodyTrigger = document.querySelector('.header__menu-toggle');
  var menuBody = document.querySelector('.header__menu-accordion');
  if (!menuBodyTrigger) return;

  var logoElement = header.querySelector('.header__logo img');
  var logoInfo = {
    el: logoElement,
    off: logoElement.src,
    on: logoElement.src.replace('_white', '_black')
  };

  menuBodyTrigger.addEventListener('click', function (e) {
    if (menuBody.classList.contains('open')) {
      menuBody.classList.remove('open');
      document.querySelector('body').classList.remove('no-scroll');

      var parts = menuBody.querySelectorAll('.accordion-part');
      Array.prototype.slice.call(parts, 0).forEach(function (item) {
        if (item.classList.contains('open')) {
          item.classList.remove('open');
          item.classList.add('closed');
        }
      });

      if (window.scrollY == 0) {
        document.querySelector('.header').classList.remove('invert');
        logoInfo.el.src = logoInfo.off;
      }
    } else {
      menuBody.classList.add('open');
      document.querySelector('body').classList.add('no-scroll');
      document.querySelector('.header').classList.add('invert');
      logoInfo.el.src = logoInfo.on;
    }
    e.preventDefault();
  });

  var menuExpandTriggers = menuBody.querySelectorAll('.accordion-bellows-control');
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(function (item) {
    item.addEventListener('click', function (e) {
      var target = item.parentNode.parentNode;
      if (target.classList.contains('closed')) {
        target.classList.remove('closed');
        target.classList.add('open');
      } else {
        target.classList.remove('open');
        target.classList.add('closed');
      }
    });
  });

  var ticking = false;
  window.addEventListener('scroll', function (e) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.innerWidth > 768) return;
        if (window.scrollY > 0) {
          document.querySelector('.header').classList.add('invert');
          logoInfo.el.src = logoInfo.on;
        } else {
          document.querySelector('.header').classList.remove('invert');
          logoInfo.el.src = logoInfo.off;
        }
        ticking = false;
      });
      ticking = true;
    }
  });
}

function useFooterAccordionMenu() {
  var menuExpandTriggers = document.querySelectorAll('dt.accordion');
  if (!menuExpandTriggers) return;
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(function (item) {
    item.addEventListener('click', function (e) {
      item.classList.toggle('closed');
    });
  });
}

function useNewsCategoryAccordionMenu() {
  var menuBody = document.querySelector('.news__category-accordion');
  if (!menuBody) return;
  var menuExpandTriggers = menuBody.querySelectorAll('.accordion-bellows-control');
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(function (item) {
    item.addEventListener('click', function (e) {
      var target = item.parentNode.parentNode;
      if (target.classList.contains('closed')) {
        target.classList.remove('closed');
        target.classList.add('open');
      } else {
        target.classList.remove('open');
        target.classList.add('closed');
      }
    });
  });
}

function useModal() {
  var modalElement = document.getElementById('modal');
  if (!modalElement) return;
  var modal = new RModal(modalElement, {
    dialogOpenClass: 'animated fadeIn',
    dialogCloseClass: 'animated fadeOut',
    afterClose: function afterClose() {
      modalElement.querySelector('.modal-content').textContent = null;
      modalElement.querySelector('.modal-dialog').classList.remove('fadeIn', 'fadeOut', 'animated');
    }
  });

  modalElement.addEventListener('click', function (e) {
    modal.close();
  });

  document.addEventListener('keydown', function (e) {
    modal.keydown(e);
  }, false);

  var modalOpenTriggers = document.querySelectorAll('.show-movie-modal');
  Array.prototype.slice.call(modalOpenTriggers, 0).forEach(function (item) {
    var isYoutube = item.classList.contains('youtube');
    item.addEventListener('click', function (e) {
      e.preventDefault();
      if (isYoutube) {
        var matches = item.href.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);
        if (matches && matches[2].length == 11) {
          var modalContentYoutube = document.createElement('div');
          modalContentYoutube.classList.add('modal-content-youtube');
          var iframeWrapper = document.createElement('div');
          modalContentYoutube.appendChild(iframeWrapper);
          var iframe = document.createElement('iframe');
          iframe.width = 510;
          iframe.height = 287;
          iframe.src = 'https://www.youtube.com/embed/' + matches[2] + '?rel=0';
          iframe.setAttribute('playsinline', 1);
          iframe.setAttribute('frameborder', 0);
          iframeWrapper.appendChild(iframe);
          modalElement.querySelector('.modal-content').appendChild(modalContentYoutube);
        }
      } else {
        var video = document.createElement('video');
        video.src = item.href;
        video.controls = 'controls';
        video.setAttribute('playsinline', 'playsinline');
        video.addEventListener('loadeddata', function (e) {
          modalElement.querySelector('.modal-content').appendChild(video);
        });
      }
      modal.open();
    });
  });

  window.modal = modal;
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// base.js